import React from "react";

const Content = ({ children }) => {
  return <div className="content">{children}</div>;
};

export default Content;
